module.exports = __webpack_public_path__ + "img/google_logo.a6ece1ea.png";